import * as types from 'modulesV2/constants';

export function requestDistrictConfiguration() {
  return {
    type: types.REQUEST_DISTRICT_CONFIGURATION,
  };
}

export function requestDistrictConfigurationSuccess(data) {
  return {
    type: types.REQUEST_DISTRICT_CONFIGURATION_SUCCESS,
    data,
  };
}

export function requestDistrictConfigurationFailure(error) {
  return {
    type: types.REQUEST_DISTRICT_CONFIGURATION_FAILURE,
    error,
  };
}
